<template>

  <div class="login">
    
   <form @submit.prevent="handleLoginSubmit($event)">
      <div class="modal-card" style="width: 300px; margin:0 auto;">
          <header class="modal-card-head">
              <p class="modal-card-title">Login</p>
          </header>
          <section class="modal-card-body">

                <b-field label="Guest login">
                  <button type="button" @click.prevent.stop="guestLogin()" class="button is-primary is-fullwidth">
                      <b-icon pack="fas" icon="mask"></b-icon>
                      <span>Login as guest</span>
                  </button>
                </b-field>

                <hr>

                <b-field label="Email">
                    <b-input
                        type="email"
                        v-model="user.email"
                        placeholder="Your email address"
                        required
                      >
                    </b-input>
                </b-field>

                <b-field label="Password" >
                  <b-input type="password"
                      placeholder="Enter you password"
                      v-model="user.password"
                      password-reveal
                      icon-pack="fas"
                      required
                  >
                  </b-input>
                </b-field>

            </section>
          <footer class="modal-card-foot">
              <button class="button" type="button" @click="$parent.close()">Close</button>
              <button type="submit" class="button is-primary">Login</button>
          </footer>
      </div>
  </form>

  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {

  name: 'Login',

  props: [],

  data(){
      return{
         user: {
            email: '',
            password: ''
        }
      }
  },

  computed:{

  },

  mounted(){
     
  },

  components:{

  },

  methods:{
    
    ...mapActions(['userLogin', 'guestLogin']),

    handleLoginSubmit(event){
        
        this.userLogin(this.user);
    }
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.login {
 
text-align:left;
}





</style>